import React from "react";
import { cn } from "../../../utils/twMerge";

const NumberedHeading = ({ number, title, className}) => {
  return (
    <h1 className={cn("font-bold text-5xl md-max:text-2xl flex gap-3 items-start", className)}>
      <div className="flex justify-center items-center size-12 text-3xl md-max:text-xl md-max:size-8 font-light rounded-full border border-black">
        {number}
      </div>
      {title}
    </h1>
  );
};

export default NumberedHeading;
